import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import openInAnotherTab from "../../../../assets/icons/openInAnotherTab.svg";
import CustomTooltip from '../../../RecicleBin/components/CustomTooltip';
import { filesSelected } from '../../WorkSpaceItemListFile';
import WorkSpaceDeleteListFileComponentImage from '../../WorkSpaceItemListFileComponentImage';

interface SelectedListProps {
  listItem: filesSelected[];
  onclick?: (itemId: string) => void;
  withCounterInFooter?: boolean;
}

const SelectedList: React.FC<SelectedListProps> = ({ listItem, onclick, withCounterInFooter = false }) => {
  const { t, i18n } = useTranslation();
  
  return (
    <div style={{ marginTop: "20px" }}>
      <div style={{ 
          border: "1px solid rgb(45, 45, 45, 0.2)", 
          borderBottom: "none",
          height: "44px",
          paddingLeft: "12px",
          borderRadius: "4px 4px 0 0",
          display: "flex",
          alignItems: "center",
          textAlign: "left", 
          fontSize: "14px", 
          color: "#575757", 
          alignContent: "center"
          }}>
          {t("SelectedList.Name")}
        </div>
      <div style={{ border: "1px solid rgb(45, 45, 45, 0.2)", width: "100%", height: "162px", borderRadius: !withCounterInFooter ? "0 0 4px" : "0", overflowY: 'auto', scrollbarWidth: "thin" }}>
        {listItem && listItem.map((item, index) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              borderBottom: listItem.length - 1 === index && index > 4 ? "" : "1px solid rgb(45, 45, 45, 0.2)",
              width: "100%",
              height: "44px"
            }}
            key={item?.id}
          >
            <div style={{padding: "12px", borderRight: "1px solid rgb(45, 45, 45, 0.2)", width: "44px", height: "100%" }}>
              <WorkSpaceDeleteListFileComponentImage boxLayout extension={item?.extension} isFolder={item?.isFolder} />
            </div>
            <div style={{ paddingLeft: "10px", width:"100%", height:"100%", alignContent: "center",textAlign: "left",overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
              {item?.name}
              {onclick &&
                <CustomTooltip
                  text={t("RecicleBin.selectedListTooltipText")}
                  backgroundColor="#22638D"
                  marginLeft="88px !important"
                >
                  <Button 
                    sx={{
                      marginRight:"4px", 
                      height:"28px", 
                      width:"28px", 
                      minWidth:"0px",
                      borderRadius:"50%",
                      '&:hover':{
                        backgroundColor:"rgb(34, 99, 141, 0.1)"
                      }
                    }} 
                    onClick={()=>onclick(item?.id)}
                  >
                    <img src={openInAnotherTab} alt='openInAnotherTab'/>
                  </Button>
                </CustomTooltip>
              }
            </div>
          </div>
        ))}
      </div>
      {withCounterInFooter && (
        <div style={{ 
          border: "1px solid rgb(45, 45, 45, 0.2)", 
          borderTop: "none",
          height: "44px",
          paddingLeft: "12px",
          borderRadius: "0 0 4px 4px",
          display: "flex",
          alignItems: "center",
          textAlign: "left", 
          fontSize: "14px", 
          color: "#575757", 
          alignContent: "center"
          }}>
          {listItem.length} {listItem.length === 1 ? t("SelectedList.ItemSelected") : t("SelectedList.ItemsSelected")}
        </div>
      )}
    </div>
  );
};

export default SelectedList;
